module.exports = __webpack_public_path__ + "img/13.71e27e29.png";